import { capitalize } from 'vue';

import Validatable from '@/validator/Validatable';
import i18n from '@/vueI18n';

export interface IOwnerYieldManagerSspAPI {
  owner_yield_manager_ssp_id: number;
  yield_manager_ssp_id: number;
  yield_manager_ssp: IOwnerYieldManagerSspAPI;
  name: string;
  domain: string;
  timeout: number;
  notes: string;
  active: boolean;
  api_key: string;
  logo_uri: string;
}

export default class OwnerYieldManagerSsp extends Validatable {
  type: string;
  yieldManagerSspID: number;
  name: string;
  domain: string;
  responseTimeout: number;
  notes: string;
  isActive: boolean;
  apiKey: string;
  logoUri: string;
  revealApiKey: boolean;

  constructor(
    id = -1,
    yieldManagerSspID = -1,
    name = null,
    domain = null,
    responseTimeout = null,
    notes = null,
    isActive = null,
    apiKey = null,
    logoUri = null,
  ) {
    super();
    this.type = 'OwnerYieldManagerSsp';
    this.id = id;
    this.yieldManagerSspID = yieldManagerSspID;
    this.name = name;
    this.domain = domain;
    this.responseTimeout = responseTimeout;
    this.notes = notes;
    this.isActive = isActive;
    this.apiKey = apiKey;
    this.logoUri = logoUri;

    this.revealApiKey = false;
  }

  get isActiveDescription() {
    if (this.isActive) {
      return capitalize(i18n.global.t('actions.yes'));
    }
    return capitalize(i18n.global.t('actions.no'));
  }

  get displayName() {
    return this.name || this.domain;
  }

  static get expands() {
    return ['yield_manager_ssp'];
  }

  static fromApi(apiObject: IOwnerYieldManagerSspAPI) {
    return new OwnerYieldManagerSsp(
      apiObject.owner_yield_manager_ssp_id,
      apiObject.yield_manager_ssp_id,
      apiObject.name == null || apiObject.name === ''
        ? apiObject.yield_manager_ssp?.domain || apiObject.domain
        : apiObject.name,
      apiObject.yield_manager_ssp?.domain || apiObject.domain,
      apiObject.timeout,
      apiObject.notes,
      apiObject.active,
      apiObject.api_key,
      apiObject.logo_uri,
    );
  }

  toApi() {
    return {
      owner_yield_manager_ssp_id: this.id,
      yield_manager_ssp_id: this.yieldManagerSspID,
      name: this.name,
      domain: this.domain,
      yield_manager_ssp: { domain: this.domain },
      timeout: this.responseTimeout,
      notes: this.notes,
      active: this.isActive,
      api_key: this.apiKey,
      logo_uri: this.logoUri,
    };
  }

  static fromObject(obj) {
    return super.fromObject(obj, new OwnerYieldManagerSsp());
  }

  static validatorCreateRules() {
    return {
      domain: 'required|not_empty_or_whitespace|domain',
      apiKey: 'required|not_empty_or_whitespace',
      responseTimeout: 'required|numeric:int|min_value:0|max_value:20000',
      isActive: 'required',
    };
  }
}
